import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Modal, Button } from 'react-bootstrap';
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class PaymentPending extends Component {
    render() {
        return (
            <>
                <div className="">
                    <Modal className="modal_div joinplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Cash Payment">Cash Payment</Trans></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="religion_modal paymentsuccess_modal">
                            <div className=''>
                                <p><Trans i18nKey="Your cash payment request is pending. Kindly contact admin for approval.">Your cash payment request is pending. Kindly contact admin for approval.</Trans></p>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </>
        );
    }
}

export default PaymentPending;
